import { lazy } from "react";

// Each page registers its own case here when it is created. A case that
// lazy-imports a module which does not exist yet fails the production build
// outright — `import()` paths are resolved at build time, not when the route
// is opened.

function load(code) {
  switch (code) {
    case "ai/prompt-template/list":
      return lazy(() => import("views/ai/prompt-template/list"));
    case "ai/prompt-template/editor":
      return lazy(() => import("views/ai/prompt-template/editor"));
    case "ai/task-config/list":
      return lazy(() => import("views/ai/task-config/list"));
    case "ai/task-config/editor":
      return lazy(() => import("views/ai/task-config/editor"));
    case "ai/task-run/list":
      return lazy(() => import("views/ai/task-run/list"));
    case "ai/task-run/detail":
      return lazy(() => import("views/ai/task-run/detail"));
    case "ai/status/list":
      return lazy(() => import("views/ai/status/list"));
    case "ai/status/detail":
      return lazy(() => import("views/ai/status/detail"));
    case "ai/model-price/list":
      return lazy(() => import("views/ai/model-price/list"));
    case "ai/model-price/editor":
      return lazy(() => import("views/ai/model-price/editor"));
    default:
      return null;
  }
}
export default load;
